import { useState } from 'react'
import { Button, Flex, Alert, AlertIcon, AlertDescription } from '@chakra-ui/react'

import { Plus } from 'components/icons'
import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function AdmissãoPadraoAGSUSPrazoDeterminado() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch } = formMethods
  const [visibleDependent2, setVisibleDependent2] = useState(false)
  const [visibleDependent3, setVisibleDependent3] = useState(false)
  const [visibleDependent4, setVisibleDependent4] = useState(false)
  const [visibleDependent5, setVisibleDependent5] = useState(false)
  const [visibleDependent6, setVisibleDependent6] = useState(false)

  if (!questions) return null

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const possuiCTPSDigital = watch ? watch(`form_answers.${titleForQuestion['CTPS digital?']}`) : undefined

  const deficienciaFisica = watch ? watch(`form_answers.${titleForQuestion['Deficiência física']}`) : undefined

  const possuiContaCorrenteOuContaSalarioNoBancoDoBrasil = watch
    ? watch(`form_answers.${titleForQuestion['Possui conta corrente ou conta salário no Banco do Brasil?']}`)
    : undefined

  const possuiChavePIXVinculadaAoCPF = watch
    ? watch(`form_answers.${titleForQuestion['Possui chave PIX vinculada ao CPF?']}`)
    : undefined

  const possuiDependente = watch ? watch(`form_answers.${titleForQuestion['Possui dependente?']}`) : undefined

  const declaraDependente1NoIRPF = watch
    ? watch(`form_answers.${titleForQuestion['Dependente 1 - Declara o dependente no IRPF']}`)
    : undefined

  const declaraDependente2NoIRPF = watch
    ? watch(`form_answers.${titleForQuestion['Dependente 2 - Declara o dependente no IRPF']}`)
    : undefined

  const declaraDependente3NoIRPF = watch
    ? watch(`form_answers.${titleForQuestion['Dependente 3 - Declara o dependente no IRPF']}`)
    : undefined

  const declaraDependente4NoIRPF = watch
    ? watch(`form_answers.${titleForQuestion['Dependente 4 - Declara o dependente no IRPF']}`)
    : undefined

  const declaraDependente5NoIRPF = watch
    ? watch(`form_answers.${titleForQuestion['Dependente 5 - Declara o dependente no IRPF']}`)
    : undefined

  const declaraDependente6NoIRPF = watch
    ? watch(`form_answers.${titleForQuestion['Dependente 6 - Declara o dependente no IRPF']}`)
    : undefined

  const declaracaoNepotismo = watch ? watch(`form_answers.${titleForQuestion['Declaração de nepotismo']}`) : undefined

  const seuProcessoSeletivoSeraPorProcessoSeletivoSimplificadoOuPorIndicacao = watch
    ? watch(
        `form_answers.${titleForQuestion['Seu processo seletivo será por processo seletivo simplificado ou por indicação?']}`
      )
    : undefined

  const eMenorde18anos = watch ? watch(`form_answers.${titleForQuestion['É menor de 18 anos?']}`) : undefined

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        const questionAboutDependent = question.title?.includes('Dependente')
        const match = question.title?.match(/Dependente (\d+) -/)
        let number = null

        if (questionAboutDependent) {
          if (match) {
            number = parseInt(match[1], 10)
          }
        }

        if (number == 1 && possuiDependente != 'Sim') {
          return <></>
        }

        //DEPENDENTE 1
        if (number == 1) {
          if (question.title == 'Dependente 1 - Comprovante do CPF' && declaraDependente1NoIRPF != 'Sim') {
            return <></>
          }
          if (question.title == 'Dependente 1 - Comprovante de vínculo' && declaraDependente1NoIRPF != 'Sim') {
            return <></>
          }
        }

        //DEPENDENTE 2
        if (number == 2 && !visibleDependent2) {
          if (question.title == 'Dependente 2 - CPF' && possuiDependente == 'Sim') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent2(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar dependente 2
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 2) {
          if (question.title == 'Dependente 2 - Comprovante do CPF' && declaraDependente2NoIRPF != 'Sim') {
            return <></>
          }
          if (question.title == 'Dependente 2 - Comprovante de vínculo' && declaraDependente2NoIRPF != 'Sim') {
            return <></>
          }
        }

        //DEPENDENTE 3
        if (number == 3 && !visibleDependent3) {
          if (question.title == 'Dependente 3 - CPF' && visibleDependent2 && possuiDependente == 'Sim') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent3(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar dependente 3
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 3) {
          if (question.title == 'Dependente 3 - Comprovante do CPF' && declaraDependente3NoIRPF != 'Sim') {
            return <></>
          }
          if (question.title == 'Dependente 3 - Comprovante de vínculo' && declaraDependente3NoIRPF != 'Sim') {
            return <></>
          }
        }

        //DEPENDENTE 4
        if (number == 4 && !visibleDependent4) {
          if (question.title == 'Dependente 4 - CPF' && visibleDependent3 && possuiDependente == 'Sim') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent4(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar dependente 4
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 4) {
          if (question.title == 'Dependente 4 - Comprovante do CPF' && declaraDependente4NoIRPF != 'Sim') {
            return <></>
          }
          if (question.title == 'Dependente 4 - Comprovante de vínculo' && declaraDependente4NoIRPF != 'Sim') {
            return <></>
          }
        }

        //DEPENDENTE 5
        if (number == 5 && !visibleDependent5) {
          if (question.title == 'Dependente 5 - CPF' && visibleDependent4 && possuiDependente == 'Sim') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent5(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar dependente 5
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 5) {
          if (question.title == 'Dependente 5 - Comprovante do CPF' && declaraDependente5NoIRPF != 'Sim') {
            return <></>
          }
          if (question.title == 'Dependente 5 - Comprovante de vínculo' && declaraDependente5NoIRPF != 'Sim') {
            return <></>
          }
        }

        //DEPENDENTE 6
        if (number == 6 && !visibleDependent6) {
          if (question.title == 'Dependente 6 - CPF' && visibleDependent5 && possuiDependente == 'Sim') {
            return (
              <Button
                key={index}
                onClick={() => setVisibleDependent6(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar dependente 6
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (number == 6) {
          if (question.title == 'Dependente 6 - Comprovante do CPF' && declaraDependente6NoIRPF != 'Sim') {
            return <></>
          }
          if (question.title == 'Dependente 6 - Comprovante de vínculo' && declaraDependente6NoIRPF != 'Sim') {
            return <></>
          }
        }

        //CTPS
        if (
          question.title == 'CTPS - Número' ||
          question.title == 'CTPS - UF' ||
          question.title == 'CTPS - Data de emissão' ||
          question.title == 'CTPS - Série' ||
          question.title == 'CTPS - Comprovante'
        ) {
          if (possuiCTPSDigital == 'Não') {
            return (
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        //DEFICIÊNCIA FÍSICA
        if (question.title == 'Deficiência física - Laudo PCD') {
          if (deficienciaFisica != 'Sim') {
            return <></>
          }
        }

        //AGÊNCIA - DÍGITO - CONTA
        if (
          question.title == 'Agência' ||
          question.title == 'Dígito da agência' ||
          question.title == 'Conta' ||
          question.title == 'Dígito da conta' ||
          question.title == 'Comprovante de dados bancários: Conta corrente ou Conta salário'
        ) {
          if (
            possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Conta Corrente' ||
            possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Conta Salário'
          ) {
            return (
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        //Agência providencie a abertura de uma conta salário para você?
        if (question.title == 'Gostaria que a Agência providencie a abertura de uma conta salário para você?') {
          if (possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Não') {
            return (
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        //Possui chave PIX vinculada ao CPF?
        if (question.title == 'Possui chave PIX vinculada ao CPF?') {
          return (
            <Flex key={index} bg="bgContent" rounded="md" p={2} flexDir="column">
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
              {possuiChavePIXVinculadaAoCPF == 'Não' && (
                <Alert status="warning" rounded="md" mt={2}>
                  <AlertIcon />
                  <AlertDescription>
                    Obs: Caso você ainda não tenha uma chave PIX cadastrada em seu CPF, será necessário realizar o
                    cadastro, pois os pagamentos durante os três primeiros meses serão efetuados por meio dessa
                    modalidade
                  </AlertDescription>
                </Alert>
              )}
            </Flex>
          )
        }

        //Possui chave PIX vinculada ao CPF?
        if (question.title == 'Possui chave PIX vinculada ao CPF?') {
          return (
            <Flex key={index} bg="bgContent" rounded="md" p={2} flexDir="column">
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
              {possuiChavePIXVinculadaAoCPF == 'Não' && (
                <Alert status="warning" rounded="md" mt={2}>
                  <AlertIcon />
                  <AlertDescription>
                    Obs: Caso você ainda não tenha uma chave PIX cadastrada em seu CPF, será necessário realizar o
                    cadastro, pois os pagamentos durante os três primeiros meses serão efetuados por meio dessa
                    modalidade
                  </AlertDescription>
                </Alert>
              )}
            </Flex>
          )
        }

        //Nepotismo - identificação da pessoa
        if (question.title == 'Nepotismo - Identificação da pessoa') {
          if (
            declaracaoNepotismo ==
            'POSSUIR cônjuge, companheiro ou parente em linha reta, colateral ou por afinidade, até o terceiro grau, inclusive, com servidor(a) investido(a) em cargo de direção, chefia ou de assessoramento, abaixo relacionado, no âmbito do AgSUS, em qualquer esfera'
          ) {
            return (
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        //INDICAÇÃO
        if (
          question.title == 'Indicação - Nome da pessoa que indicou' ||
          question.title == 'Indicação - Cargo da pessoa que fez sua indicação' ||
          question.title == 'Indicação - Oficio da pessoa que fez sua indicação'
        ) {
          if (seuProcessoSeletivoSeraPorProcessoSeletivoSimplificadoOuPorIndicacao == 'Indicação') {
            return (
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        //MENOR DE 18 ANOS
        if (
          question.title == 'CPF do Responsável' ||
          question.title == 'RG do Responsável' ||
          question.title == 'Comprovante de documento RG ou CPF do Responsável' ||
          question.title == 'Grau de Parentesco do Responsável' ||
          question.title == 'Telefone do Responsável'
        ) {
          if (eMenorde18anos == 'Sim') {
            return (
              <CustomFormViewerQuestion
                key={question.id}
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
